import { createActions } from 'redux-actions';
import { COURSE_LIST } from '../actionTypes';

export default createActions({
  [COURSE_LIST]: (state) => {
    return state;
  }
});
